import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Switch,
} from "@material-ui/core";
import { toast } from "react-toastify";

import { createAgent, updateAgent } from "../../services/agentIa";
import toastError from "../../errors/toastError";

const EMPTY = {
  name: "",
  label: "",
  system_prompt: "",
  active: true,
  inkamoney_lookup_enabled: false,
};

const AgentIaModal = ({ open, onClose, agent, onSaved }) => {
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setForm(
        agent
          ? {
              name: agent.name,
              label: agent.label || "",
              system_prompt: agent.system_prompt || "",
              active: agent.active,
              inkamoney_lookup_enabled: agent.inkamoney_lookup_enabled || false,
            }
          : EMPTY
      );
    }
  }, [open, agent]);

  const handleSave = async () => {
    if (!form.name.trim()) {
      toast.error("Ponle un nombre al agente.");
      return;
    }
    setSaving(true);
    try {
      if (agent) {
        await updateAgent(agent.id, form);
        toast.success("Agente actualizado.");
      } else {
        await createAgent(form);
        toast.success("Agente creado.");
      }
      onSaved();
      onClose();
    } catch (err) {
      toastError(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{agent ? "Editar agente" : "Nuevo agente"}</DialogTitle>
      <DialogContent dividers style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <TextField
          label="Nombre"
          variant="outlined"
          size="small"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          autoFocus
        />
        <TextField
          label="Etiqueta / unidad de negocio"
          placeholder="ej. Canal Postventa"
          variant="outlined"
          size="small"
          value={form.label}
          onChange={(e) => setForm({ ...form, label: e.target.value })}
        />
        <TextField
          label="Instrucciones del agente (prompt del sistema)"
          placeholder="Tono, reglas, qué nunca prometer..."
          variant="outlined"
          size="small"
          multiline
          minRows={5}
          value={form.system_prompt}
          onChange={(e) => setForm({ ...form, system_prompt: e.target.value })}
        />
        <FormControlLabel
          control={
            <Switch
              checked={form.active}
              onChange={(e) => setForm({ ...form, active: e.target.checked })}
              color="primary"
            />
          }
          label="Activo"
        />
        <FormControlLabel
          control={
            <Switch
              checked={form.inkamoney_lookup_enabled}
              onChange={(e) =>
                setForm({ ...form, inkamoney_lookup_enabled: e.target.checked })
              }
              color="primary"
            />
          }
          label="Puede consultar equipos en InkaMoney por ID/IMEI (postventa)"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancelar
        </Button>
        <Button
          onClick={handleSave}
          color="primary"
          variant="contained"
          disabled={saving}
        >
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AgentIaModal;
